/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RunPhase } from '../../models/run-phase';

export interface GetRunPhases$Params {
  productionOrderId: number;
}

export function getRunPhases(http: HttpClient, rootUrl: string, params: GetRunPhases$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RunPhase>>> {
  const rb = new RequestBuilder(rootUrl, getRunPhases.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RunPhase>>;
    })
  );
}

getRunPhases.PATH = '/api/v1/ProductionOrder/{productionOrderId}/RunPhases';
